import auth from '../config/auth'
import firebase from 'firebase'

firebase.initializeApp(auth);

const googleProvider = new firebase.auth.GoogleAuthProvider();
const firebaseAuth = firebase.auth;

function signInWithPopup() {
  return firebaseAuth().signInWithPopup(googleProvider);
}

export async function getCredential() {
  const result = await signInWithPopup()
  return { accessToken: result.credential.accessToken }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js